<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dialogues">
<div class="section level2" id="n.i.b.s.">
<h2>N.I.B.S.</h2>
<table style="width:98%;">
<colgroup>
<col width="4%"/>
<col width="80%"/>
</colgroup>
<thead>
<tr class="header">
<td align="left" colspan="2">F=Frank J=Jackie</td>
</tr>
</thead>
<tbody style="vertical-align: top;">
<tr class="odd">
<td align="left">F:</td>
<td>Jackie, what is going on?</td>
</tr>
<tr class="even">
<td align="left">J:</td>
<td>Nothing, Frank.</td>
</tr>
<tr class="odd">
<td align="left">F:</td>
<td>The wife?</td>
</tr>
<tr class="even">
<td align="left">J:</td>
<td>Okay.</td>
</tr>
<tr class="odd">
<td align="left">F:</td>
<td>Kids?</td>
</tr>
<tr class="even">
<td align="left">J:</td>
<td>Yep.</td>
</tr>
<tr class="odd">
<td align="left">F:</td>
<td>The car?</td>
</tr>
<tr class="even">
<td align="left">J:</td>
<td>AAH.</td>
</tr>
<tr class="odd">
<td align="left">J:</td>
<td>Frank, yourself?</td>
</tr>
<tr class="even">
<td align="left">F:</td>
<td>I don’t feel like saying anything. Your talking is too much and I need an aspirin.</td>
</tr>
<tr class="odd">
<td align="left">J:</td>
<td>Buffered?</td>
</tr>
<tr class="even">
<td align="left">F:</td>
<td>Yep.</td>
</tr>
<tr class="odd">
<td align="left">J:</td>
<td>How many?</td>
</tr>
<tr class="even">
<td align="left">F:</td>
<td>Two.</td>
</tr>
<tr class="odd">
<td align="left">J:</td>
<td>Later.</td>
</tr>
<tr class="even">
<td align="left">F:</td>
<td>Yeah, later.</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?f8783c00